import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		BankaBic: null as string | null,
		BankaIban: null as string | null,
		BankaTxt: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
